import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify";
import { registerEmployee } from "src/redux/api/_hr.api";
import { RegistrationFormValues } from "src/schemas/add-employee";
import { employeeKeys } from "../../EmployeeList/hook/useFetchEmployees";

export const useRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: RegistrationFormValues) => registerEmployee(values),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: employeeKeys.all,
      });
      toast.success("Employee Created!");
    },

    onError: (error) => {
      toast.error("Failed to add Employee!");
      console.error(error, 'fiailed employee registration');
    }
  })
};